<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="''"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="tit_box">
						<div class="tit"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>Healthcare Providers,</div>
						<div class="tit"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>Receive 20% Off Your First Order</div>
					</div>
					<div class="bot_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Sign up for special offers on rapid testing products your patients need. 
						<div
							class="btn_box btn_el"
							@click="goForm"
						>
							SUBMIT<img src="../../assets/img/icon_w.webp" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx is committed to your privacy. CorDx uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, see our privacy policy below.
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<div class="tit1">
								Transforming Global Diagnostics
							</div>
							<div class="tit2">
								A leader in IVD R&D, manufacturing, and<br />supply chain.
							</div>
						</div>
						<div class="right">
							<div class="txt">
								CorDx is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the United States and around the world. 
							</div>
							<div class="txt">
								With nearly two decades of IVD experience, CorDx is a leader in IVD research and development, manufacturing, and supply chain. Our proprietary line of rapid diagnostic products is recognized by families and medical professionals for reliability, affordability, and rapid results. 
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			newsData: [],  //新闻数据
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'CorDx Newsletter Sign Up | Rapid, Accurate Diagnostics';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goForm() {
			window.open('https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=1&h=AAFdikaIQ2PXFz401i3VE_HOLtHYK7BnQWKsJ4kggWf6fmweWho');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	color: #000000;
	//块2
	.block_2{
		background-color: transparent;
		background-image: linear-gradient(180deg, #FFFFFF 20%, #F1ECE6 100%);
		.block_2_main{
			width: 1250px;
			margin: 0 auto;
			padding: 100px 0;
			.msg_box{
				display: flex;
				align-items: center;
				padding-top: 80px;
				.right{
					flex: 1;
					.txt{
						font-size: 22px;
						padding: 10px 0;
					}
				}
				.left{
					flex: 1;
					.tit2{
						padding-top: 20px;
						padding-left: 80px;
						font-size: 22px;
						color: #093a98;
					}
					.tit1{
						padding-left: 80px;
						font-size: 44px;
						line-height: 1.2;
					}
				}
			}
			.title{
				text-align: center;
				font-size: 22px;
			}
		}
	}
	//块1
	.block_1{
		.block_1_main{
			.bot_box{
				padding: 24px 0 20px 0;
				background-image: linear-gradient(rgba(11, 49, 143, 1), rgba(11, 49, 143, 1));
				text-align: center;
				font-size: 24px;
				color: #ffffff;
				.btn_el{
					position: relative;
					left: 30px;
					background-color: #F26F32;
					color: #ffffff;
					border: none;
					font-size: 20px;
				}
			}
			.tit_box{
				width: 1140px;
				margin: 0 auto;
				padding: 80px 0 50px 0;
				.tit{
					font-size: 50px;
					text-align: center;
				}
			}
		}
	}
	.btn_box{
		display: inline-block;
		padding: 2px 28px 0 28px;
		height: 50px;
		line-height: 50px;
		font-size: 24px;
		color: #0B318F;
		background: transparent;
		border-radius: 37px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 18px !important;
			min-width: 18px !important;
			position: relative;
			top: 13px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box:hover{
		img{
			transform: translateX(5px);
		}
	}
}
</style>
